import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { NgRedux, select } from '@angular-redux/store';
import { Subscription } from 'rxjs';

import { AppState } from '../../../../interfaces/store.interface';

import { AnimationService } from '../../../shared/services/animation/animation.service';
import { UiActionsService } from '../../../store/actions/ui.actions';

import { CONFIG } from '../../../shared/config/config.const';

@Component({
    selector: 'app-listing-gallery',
    templateUrl: './listing-gallery.component.html',
    styleUrls: ['./listing-gallery.component.scss'],
    animations: [
        AnimationService.slideInOut(CONFIG.TRANSITION.DETAILS)
    ]
    // @TODO can we use onPush here?
})
export class ListingGalleryComponent {

    @Input() offsetTop: boolean;

    visible: boolean;

    private subscription = Subscription.EMPTY;

    constructor (
        private uiActions: UiActionsService,
        private ngRedux: NgRedux<AppState>
    ) {}

    ngOnInit () {
        this.subscription = this.ngRedux.select<boolean>(['ui', 'gallery', 'visible'])
            .subscribe(value => this.visible = value);
    }

    ngOnDestroy () {
        this.subscription.unsubscribe();
    }

    close () {
        this.uiActions.closeGallery();
    }

    next () {
        this.uiActions.setGalleryNext();
    }

    previous () {
        this.uiActions.setGalleryPrevious();
    }

}
